import { render, staticRenderFns } from "./receiptDetails.vue?vue&type=template&id=b00de590&"
import script from "./receiptDetails.vue?vue&type=script&lang=js&"
export * from "./receiptDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports